import { useEffect, useState } from 'react';

interface IUseTimerProps {
  timeInSecond: number;
  pause?: boolean;
}

const useTimer = (props: IUseTimerProps) => {
  const { timeInSecond, pause } = props;
  const [isLoading, setIsLoading] = useState(true);
  const [time, setTime] = useState(0);

  const exec = () => {
    setTime(timeInSecond);

    const interval = setInterval(() => {
      setTime((prev) => {
        if (prev === 0) {
          clearInterval(interval);
          return 0;
        }

        return prev - 1;
      });
    }, 1000);

    return interval;
  };

  useEffect(() => {
    let interval;
    if (!pause) {
      interval = exec();
    }

    return () => {
      setTime(0);
      if (interval) {
        clearInterval(interval);
      }
    };
  }, []);

  return {
    time,
    isTimeout: time <= 0,
    isLoading,
    setIsLoading,
    exec,
  };
};

export default useTimer;
